import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL || 'https://placeholder.supabase.co'
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY

const ALLOWED_PROD_REFS = ['lpnzpimxwtexazokytjo'];

if (process.env.VERCEL_ENV === 'production' && supabaseUrl) {
    const ref = supabaseUrl.match(/https:\/\/([a-z0-9]+)\.supabase\.co/)?.[1];
    if (ref && !ALLOWED_PROD_REFS.includes(ref)) {
        console.error('[SUPABASE-GUARD] Produção apontando para ref Supabase inesperado', { ref, expected: ALLOWED_PROD_REFS });
    }
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
